import { ModelInModelTree } from "../../components/cms/model-space/model-space";

/**
 * Módosítja az parméterben megadott tömböt.
 * @param modelTree 
 * @param uuid 
 * @returns 
 */
export const deleteModelFromModelTreeInModelSpaceByUUID = (modelTree: ModelInModelTree[], uuid: string): ModelInModelTree | undefined => {
    for (let i = modelTree.length - 1; i >= 0; i--) {
        if (modelTree[i].uuid === uuid) {
            const [removed] = modelTree.splice(i, 1);
            return removed;
        } else {
            const removed = deleteNodeByUUID(modelTree[i], uuid);
            if (removed) return removed;
        }
    }

    return undefined;
};

const deleteNodeByUUID = (model: ModelInModelTree, uuid: string): ModelInModelTree | undefined => {
    if (model.children) {
        for (let i = model.children.length - 1; i >= 0; i--) {
            if (model.children[i].uuid === uuid) {
                const [removed] =  model.children.splice(i, 1);
                return removed;
            } else {
                const removed = deleteNodeByUUID(model.children[i], uuid);
                if (removed) return removed;
            }
        }
    }
    
    return undefined;
};